import DeerWalkLogo from "@/assets/experience/DeerwalkPng.png";
import AgoniusLogo from "@/assets/experience/AgoniusPng.png";
import HyperCeLogo from "@/assets/experience/Hypercepng.png";
import TechBadge from "./TechIcons";
import { MotionDiv } from "@/components/animations/MotionDivWrapper";
import { BlurPopUpByWord } from "../animations/PopUpAnimations";

const experienceData = [
  {
    company: "HyperCE",
    position: "Frontend Developer / Team Lead",
    duration: "Dec 2024 - Present",
    companyLink: "https://www.hyperce.io/",
    description: [
      "Led the development of scalable e-commerce platforms with seamless checkout flows, integrating shipping, payments (Stripe), and authentication using OAuth and native strategies.",
      "Developed the complete frontend of B2Box, a B2B platform for importing goods from China and selling across South America, featuring regional stores with localized language and currency support.",
      "Built a React-based Admin Panel for store management, while the customer-facing side was developed using Remix.js for performance, SEO, and maintainability.",
      "Collaborated closely with backend teams on a Vendure-based NestJS and GraphQL architecture, ensuring efficient data flow and modular integration.",
      "Contributed to Picadilly, a U.S.-based restaurant chain with 40+ locations, supporting dine-in, group dining, catering, and family dining services through a multi-vendor system.",
      "Led and mentored junior developers, conducted technical analysis, and delegated tasks effectively across multiple concurrent projects.",
      "Promoted from mid-level to lead developer due to strong product knowledge, technical expertise, and effective collaboration across teams.",
    ],
    logo: HyperCeLogo,
    type: "Full Time",
    stack: [
      "Remix.js",
      "React.js",
      "Next.js",
      "NestJS",
      "GraphQL",
      "Vendure",
      "Redux",
      "Jotai",
      "Zustand",
      "Apollo Client",
      "Stripe",
    ],
  },
  {
    company: "Agonius",
    position: "Frontend Developer (Part-Time)",
    duration: "Nov 2024 - Nov 2025",
    companyLink: "https://www.app.agonius.de/",
    description: [
      "Built a grant application management platform with a custom Gantt chart interface for visualizing project timelines.",
      "Integrated AWS REST APIs for efficient data synchronization and dynamic updates.",
      "Enhanced UI responsiveness and consistency across devices using React, Tailwind CSS, and TypeScript.",
    ],
    logo: AgoniusLogo,
    type: "Part Time",
    stack: ["React", "TypeScript", "Tailwind CSS", "AWS", "Stripe"],
  },
  {
    company: "Deerwalk Training Center",
    position: "MERN Stack Developer Trainee",
    duration: "Jul 2024 - Oct 2024",
    companyLink: "https://deerwalktrainingcenter.com/",
    description: [
      "Completed an intensive MERN Stack training program focusing on modern full-stack development.",
      "Developed multiple hands-on projects featuring CRUD operations, authentication, and RESTful APIs.",
      "Gained strong practical experience in React, Node.js, Express.js, and MongoDB.",
    ],
    logo: DeerWalkLogo,
    type: "Trainee",
    stack: ["React", "Node.js", "Express.js", "MongoDB"],
  },
];

const Experience = () => {
  return (
    <div
      className="bg-[linear-gradient(to_bottom,rgba(255,255,255,0.05),transparent_40%)] mt-14 lg:mt-40"
      id="experience"
    >
      <div className="container w-full mx-auto py-20 lg:py-40">
        <h2 className="text-center text-4xl uppercase">
          <BlurPopUpByWord text=" Experience" />
        </h2>
        <div className="relative mt-24 w-full flex flex-col items-center">
          <div className="absolute left-0 transform -translate-x-1/2 h-full w-[2px] bg-white/20">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-white"></div>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-white"></div>
          </div>
          <div className="flex flex-col gap-24 w-full pl-6 sm:pl-10">
            {experienceData.map((item, index) => (
              <MotionDiv
                key={item.company + index}
                direction="up"
                delay={0.2 * index}
                className="relative"
              >
                <div className="absolute -left-[7.3vw] md:-left-[4.4vw] lg:-left-[2.7vw] top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-white z-10" />
                <div className="bg-black/20 border border-[#8A8F98]/30 w-full rounded-md p-6 hover:bg-black/30 transition-all duration-300">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                    <p className="font-semibold text-sm">{item.position}</p>
                    <p className="font-semibold text-xs text-[#8A8F98]">
                      {item.duration}
                    </p>
                  </div>

                  <div className="flex items-center justify-between gap-3 mt-3 flex-wrap">
                    <a
                      href={item.companyLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2.5 hover:opacity-90 transition-all"
                    >
                      <img
                        src={item.logo}
                        alt={item.company}
                        className="w-7 h-7 rounded-md"
                      />
                      <p className="text-xs uppercase font-bold">
                        {item.company}
                      </p>
                    </a>
                    <p className="text-[9px] uppercase font-semibold text-white bg-background border border-[#8A8F98]/30 px-2 py-1 rounded-md">
                      {item.type}
                    </p>
                  </div>

                  <div className="mt-3 mx-2">
                    <ul className="list-disc list-inside space-y-1.5">
                      {item.description.map((desc, index) => (
                        <li
                          key={index}
                          className="text-sm text-white leading-relaxed"
                        >
                          {desc}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-4 mx-1 flex flex-wrap gap-2">
                    {item.stack.map((tech, idx) => (
                      <TechBadge key={tech} name={tech} idx={idx} />
                    ))}
                  </div>
                </div>
              </MotionDiv>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
